export default "__VITE_ASSET__BCPO6bXm__"